export default __webpack_public_path__ + "static/media/achievement.01ded99e.svg";